import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class PasswordResetInit {

    constructor (private http: HttpClient) {}

    save(mail: string): Observable<any> {
        return this.http.post('/api/account/reset-password/init', mail);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/init/password-reset-init.service.ts